import React, { useMemo } from 'react';
import Text from '@/components/ui/Text';
import { Image } from './types';
import useDuplicateImagesStore from './useDuplicateImagesStore';

interface MergeSummaryBannerProps {
  checkedImageCount: number;
  duplicateImages: Image[];
  newImage: Image;
}

const MergeSummaryBanner = ({
  checkedImageCount,
  duplicateImages,
  newImage,
}: MergeSummaryBannerProps) => {
  const primaryImageId = useDuplicateImagesStore(state => state.primaryImageId);

  const primaryImage = useMemo(() => (
    [newImage, ...duplicateImages].find(image => image.id === primaryImageId)
  ), [primaryImageId, newImage, duplicateImages]);

  if (!primaryImage) return null;

  const totalImageCount = duplicateImages.length + 1;

  return (
    <div className="tw-max-w-full tw-flex tw-justify-end tw-mt-2 tw-py-1 tw-px-3 tw-rounded-lg tw-bg-light-grey">
      <Text className="" size="sm" tag="div">
        <strong>{checkedImageCount}</strong>
        &nbsp;of&nbsp;
        <strong>{totalImageCount}</strong>
        &nbsp;images will be merged with&nbsp;
        <strong>{primaryImage.fileName}</strong>
      </Text>
    </div>
  );
};

export default MergeSummaryBanner;
